import type { GridApi, IRowNode } from "ag-grid-community";
import React from "react";

import { SuperRowLayout } from "./SuperRowLayout";

import type { RoleCompetencyDetail, SuperRowContext, SuperRowRow } from "./types";

type RoleCompetencySuperRowContentProps = {
	data: SuperRowRow<RoleCompetencyDetail>;
	node: IRowNode;
	api: GridApi;
	context: SuperRowContext;
};

// Role-interior flavor of the super row content: the endpoint already joins description/levels onto
// the row itself (no separate competencies dict to look up), and this surface has no "current level"
// concept — only the Expected chip ever renders.
export const RoleCompetencySuperRowContent = ({
	data,
	node,
	api,
	context,
}: RoleCompetencySuperRowContentProps): React.ReactElement => {
	const rowId = data.parentRowId ?? data._rowId;

	return (
		<SuperRowLayout
			node={node}
			api={api}
			context={context}
			rowId={rowId}
			description={data.description}
			levels={data.levels}
			isLevelExpected={(rank) => data.expected_level === rank}
		/>
	);
};
